import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { FormGroupGetAllService } from '../../services';

export const fetchFormGroupGetAll = createAsyncThunk(
    'formGroupGetAll/fetchFormGroupGetAll',
    async () => {
        const response = await FormGroupGetAllService()
        return response.result;
    }
);

const formGroupGetAllSlice = createSlice({
    name: 'formGroupGetAll',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFormGroupGetAll.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFormGroupGetAll.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchFormGroupGetAll.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default formGroupGetAllSlice.reducer;
